import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { AbstractFormContainer } from '@shared/classes/abstract-form-container';
import { AddressNoteErrors } from '@shared/errors/error-messages';
import { getError } from '@shared/utils/error.utils';
import {
    AddressNoteExtendedPattern,
    AddressNoteMaxLength,
} from '@shared/modules/address-components/address-note/address-note.constants';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-address-sender-note',
    templateUrl: './address-sender-note.component.html',
    styleUrls: ['./address-sender-note.component.scss'],
})

export class AddressSenderNoteComponent extends AbstractFormContainer implements OnInit {
    protected readonly getError = getError;
    protected readonly AddressNoteErrors = AddressNoteErrors;

    @Input() controlName = 'Note';

    constructor(protected formBuilder: UntypedFormBuilder) {
        super();
    }

    get addressNoteControl(): AbstractControl {
        return this.form.get(this.controlName);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    addFormControls() {
        const noteControl = new FormControl('', [
            Validators.maxLength(AddressNoteMaxLength),
            Validators.pattern(AddressNoteExtendedPattern),
        ]);
        this.form.addControl(this.controlName, noteControl);
    }
}
